import React from 'react'
import Hero from '../component/Hero'
import StatsBar from '../component/StatsBar'
import Brands from '../component/Brands'
import Team from '../component/Team'
import Side from '../component/Side'

const Home = () => {
    return (
        <>
            <Side />
            <Hero />
            <StatsBar />
            <section className="hero-section-home"  >

                <div className="container hero-content text-start">
                    {/* <h1>Ghayar</h1> */}
                    <p>
                        Ghayar is a UAE-based digital e-commerce platform dedicated to making
                        vehicle spare parts easy to find, reliable to buy, and fast to receive.
                        Founded in Dubai in 2019, we started with a clear mission: to simplify
                        access to high-quality automotive parts through technology, transparency, and trust.

                    </p>
                    <p>
                        Today, Ghayar operates through 9 local and international branches,
                        delivering to over 110 countries worldwide. With 20,000+ product lines,
                        we offer a comprehensive range of spare parts for a wide variety of vehicle
                        makes and models, serving individuals, workshops, and businesses globally.
                    </p>
                    <p>
                        We work closely with trusted suppliers to ensure every product meets strict standards
                        of quality and authenticity. Backed by secure payment options, efficient logistics,
                        and responsive customer support, we provide a smooth and dependable
                        experience from order to delivery.
                    </p>
                    <p>
                        With a growing presence across the Middle East and Africa — and more regions on the way
                        — Ghayar continues to build its reputation as a trusted global automotive parts platform,
                        driven by technology and exceptional service.
                    </p>
                </div>
            </section>
            <Brands />
            <Team />
            {/* <Career /> */}
        </>
    )
}

export default Home